<template>
  <div class="mainDrawer">
    <img style="width: 30px;height: 100px;cursor: pointer" :class="drawer?'openBtn':'closeBtn'"
         @click="changeLeftDrawer" @touchstart="changeLeftDrawer"
         :src="drawer?dialogLeft:dialogRight"/>
    <el-drawer
      title="设置"
      :visible.sync="drawer"
      direction="ltr"
      :with-header="false"
      :wrapperClosable="false"
      :modal="false"
      size="100%"
    >
      <el-collapse v-model="activeNames"  @change="handleChange" style="padding: calc(8vh) 20px 20px 20px;">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="collapseTitle">
              平面几何图形
            </div>
          </template>
          <div class="graphClass">
            <div class="graphItemClass">
              <img style="height: 36px;width: 36px" src="../../../assets/images/antVx6/Circle.png"
                   @mousedown="startDrag('circle',null,$event)"/>
            </div>
          </div>
          <div class="graphClass">
            <div class="graphItemClass">
              <img style="height: 36px;width: 36px" src="../../../assets/images/antVx6/polygon.png"
                   @mousedown="startDrag('polygon',null,$event)"/>
            </div>
          </div>
          <div class="graphClass">
            <div class="graphItemClass">
              <img style="height: 36px;width: 36px" src="../../../assets/images/antVx6/text.png"
                   @mousedown="startDrag('text-block',null,$event)"/>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="collapseTitle">
              物联网设备图标
            </div>
          </template>
          <div class="graphClass">
            <div class="graphItemClass">
              <el-popover
                width="150"
                trigger="hover"
                popper-class="popoverStyle">
                <p style="display: flex;justify-content: center">添加设备图标</p>
                <div slot="reference">
                  <img style="height: 36px;width: 36px" src="../../../assets/images/antVx6/add.png"
                    @touchstart="changeDialog('device')"   @click="changeDialog('device')"/>
                </div>
              </el-popover>

            </div>
          </div>
          <div class="graphClass" v-for="(item,index) in deviceList" :key="index">
            <div class="graphItemClass">
              <el-popover
                width="150"
                trigger="hover"
                popper-class="popoverStyle">
                <p style="display: flex;justify-content: center">{{ item.name }}</p>
                <div style="width: 100%;display: flex;justify-content: center">
                  <el-button size="mini" @touchstart="deleteImage(item.id)"  @click="deleteImage(item.id)">删除</el-button>
                </div>
                <div slot="reference">
                  <img style="height: 36px;width: 36px" :src="$ftpUrl+item.iconUrl"
                       @mousedown="startDrag('image',$ftpUrl+item.iconUrl,$event)"/>
                </div>
              </el-popover>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <div class="collapseTitle">
              背景图片
            </div>
          </template>
          <div class="graphClass">
            <div class="graphItemClass">
              <el-popover
                width="150"
                trigger="hover"
                popper-class="popoverStyle">
                <p style="display: flex;justify-content: center">添加背景图片</p>
                <div slot="reference">
                  <img style="height: 36px;width: 36px" src="../../../assets/images/antVx6/add.png"
                    @touchstart="changeDialog('bgImage')"   @click="changeDialog('bgImage')"/>
                </div>
              </el-popover>
            </div>
          </div>
          <div class="graphClass" v-for="(item,index) in bgList" :key="index">
            <div class="graphItemClass">
              <el-popover
                width="150"
                trigger="hover"
                popper-class="popoverStyle">
                <p style="display: flex;justify-content: center">{{ item.name }}</p>
                <div style="width: 100%;display: flex;justify-content: center">
                  <el-button size="mini" @touchstart="deleteImage(item.id)" @click="deleteImage(item.id)">删除</el-button>
                </div>
                <div slot="reference">
                  <img style="height: 36px;width: 36px" :src="$ftpUrl + item.iconUrl"
                       @mousedown="startDrag('image',$ftpUrl + item.iconUrl,$event,1920,800)"/>
                </div>
              </el-popover>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title">
            <div class="collapseTitle">
              网络拓扑图
            </div>
          </template>
          <div class="graphClass" v-for="(item,index) in topologyList" :key="index">
            <div class="graphItemClass">
              <el-popover
                width="150"
                trigger="hover"
                popper-class="popoverStyle">
                <p style="display: flex;justify-content: center">{{ item.cnName }}</p>
                <div slot="reference">
                  <img style="height: 36px;width: 36px" :src="$ftpUrl+item.iconTopological"
                       @mousedown="startDrag('image',$ftpUrl+item.iconTopological,$event)"/>
                </div>
              </el-popover>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-drawer>
    <!--    添加-->
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      width="30%">
      <span slot="title">
        <div style="display: flex;align-items: center;justify-content: center">添加</div>
      </span>
      <div style="width: 100%">
        <el-row style="height: 100%;width: 100%;margin-bottom: 20px;margin-top: 20px">
          <el-col v-if="addType==='device'" :span="8" style="padding-left: 20px">设备图标名称：</el-col>
          <el-col v-else :span="8" style="padding-left: 20px">背景图片名称：</el-col>
          <el-col :span="14">
            <el-input v-model="uploadName"></el-input>
          </el-col>
        </el-row>
        <el-row style="height: 100%;width: 100%">
          <el-col :span="8" v-if="addType==='device'" style="padding-left: 20px">设备图标：</el-col>
          <el-col :span="8" v-else style="padding-left: 20px">背景图片：</el-col>
          <el-col :span="14">
            <el-upload
              :action="uploadUrl"
              :headers="token"
              :accept="'image/*'"
              :auto-upload="true"
              :on-error="imageChangeError"
              :on-success="handleAvatarSuccess"
              :show-file-list="false"
              drag
              style="margin-bottom: 20px;">
              <img v-if="uploadImage" width="100%" :src="$ftpUrl+ uploadImage" alt="">
              <i v-else class="el-icon-plus" style="line-height:80px;height: 80px;width: 80px;"></i>
            </el-upload>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @touchstart="cancle()"  @click="cancle()">取 消</el-button>
        <el-button type="primary" @touchstart="saveTopologyImages()"  @click="saveTopologyImages()">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {startDragToGraph} from '../Graph/methods.js'
import {
  getTopologyImages,
  saveTopologyImages,
  deleteTopologyImages,
  getCategoryTopologyImages
} from '@/network/device-topology'
import {serviceUrl} from "@/utils/request";

export default {
  name: 'LeftDrawer',
  props: ['graph', 'drawer'],
  data() {
    return {
      // 文件上传地址
      uploadUrl: window.g.gatewayUrl.slice(0, -1) + serviceUrl.deviceService + '/api/upload',
      token: null,
      uploadImage: null,
      uploadName: null,
      addType: 'device',
      // 折叠面板，展开下标
      activeNames: ['1', '2', '3', '4'],
      // 物联网设备图标列表
      deviceList: [],
      // 背景图片
      bgList: [],
      // 网络拓扑图
      topologyList: [],
      dialogVisible: false,
      // 弹窗面板是否展开
      dialogRight: require('../../../assets/images/antVx6/dialogRight.png'),
      dialogLeft: require('../../../assets/images/antVx6/dialogLeft.png')
    };
  },
  mounted() {
    this.token = {Authorization: 'Bearer' + this.$cookies.get('token')};
    this.getTopologyImages()
    this.getCategoryTopologyImages()
  },
  methods: {
    // 成功上传区域背景图
    handleAvatarSuccess(file) {
      this.uploadImage = file.data.domain + file.data.url;
    },
    // 上传失败
    imageChangeError() {
      this.$message.error("文件上传失败!请检查网络！")
    },
    // 查询拓扑图设备图片和背景图片
    getTopologyImages() {
      getTopologyImages().then(res => {
        if (res.code === 0) {
          if (res.data) {
            this.deviceList = res.data.deviceTopologyImages
            console.log(this.deviceList)
            this.bgList = res.data.baseTopologyImages
          }
        }
      }).catch(e => {
        console.log(e)
      })
    },
    // 开始拖动模块 拖拽生成正方形或者圆形
    startDrag(type, url, e, width, height) {
      startDragToGraph(this.graph, type, url, e, width, height)
    },
    handleChange(val) {
      console.log(val);
    },
    changeLeftDrawer() {
      this.$emit('changeLeftDrawer')
    },
    changeDialog(type) {
      this.addType = type
      this.dialogVisible = true
    },
    // 保存图片
    saveTopologyImages() {
      if (this.uploadName === null) {
        this.$message.info("请输入名称！")
        return
      } else if (this.uploadImage === null) {
        this.$message.info("请上传图片！")
        return;
      }
      let object = {
        name: this.uploadName,
        type: this.addType === 'device' ? 0 : 1,
        iconUrl: this.uploadImage
      }
      saveTopologyImages(object).then(res => {
        console.log(res)
        this.$message.success('添加成功！')
        this.getTopologyImages()
        this.dialogVisible = false
        this.uploadImage = null
        this.uploadName = null
      }).catch(e => {
        console.log(e)
        this.$message.error('添加失败！')
        this.uploadImage = null
        this.uploadName = null
      })
    },
    // 取消
    cancle() {
      this.uploadImage = null
      this.uploadName = null
      this.dialogVisible = false
    },
    // 删除设备图标或背景图片
    deleteImage(id) {
      this.$confirm('确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        deleteTopologyImages(id).then(res => {
          if (res.code === 0) {
            this.$message.success('删除成功！')
            this.getTopologyImages()
          } else {
            this.$message.success('删除失败！')
          }
        }).catch(e => {
          console.log(e)
          this.$message.success('删除失败！')
        })
      })
    },
    // 查询运营平台网络拓扑图
    getCategoryTopologyImages() {
      getCategoryTopologyImages().then(res => {
        if (res.code === 0) {
          this.topologyList = res.data
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
};
</script>

<style>
.el-popover.popoverStyle {
  background-color: rgba(70, 76, 91, .9);
  border: rgba(70, 76, 91, .9);
  color: white;
  min-width: 70px;
}
</style>
<style scoped>
.mainDrawer {
  display: flex;
  justify-content: center;
}

.openBtn {
  position: absolute;
  height: 50px;
  width: 50px;
  font-size: 20px;
  left: 24%;
  top: 45%;
}

.closeBtn {
  position: absolute;
  height: 50px;
  width: 50px;
  font-size: 20px;
  left: 0;
  top: 45%;
}

.graphClass {
  width: 70px;
  height: 70px;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #314660;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
  cursor: grab;
}

.graphItemClass {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.collapseTitle {
  font-size: 15px;
  color: #FFFFFF;
}

::v-deep .el-drawer__wrapper {
  height: 100%;
  width: 24%;
  z-index: 1000 !important;
}

.el-popover.popoverStyle {
  z-index: 1000 !important;
}

::v-deep .el-drawer__body {
  overflow: auto;
  background-color: #050F26;
  box-shadow: -5px 0 30px 0 rgba(41, 155, 255, .1) inset,
  -10px 0 30px 0 rgba(41, 155, 255, 0.08) inset,
  -15px 0 30px 0 rgba(41, 155, 255, 0.05) inset,
  -20px 0 30px 0 rgba(41, 155, 255, 0.01) inset;
}

::v-deep .el-collapse-item__header {
  font-size: 16px;
  font-weight: bold;
}
</style>
